<template>
  <div class="contact">
    <div class="MainOne">
      <img src="../assets/image/客户案例_1.jpg" alt="" style="height: 500px" />
    </div>
    <div class="MainTwo">
      <div style="width: 100%; margin: 0 auto">
        <div class="right_letter">超出预期是一种常态</div>
      </div>
      <h2>客户名单</h2>
      <h3>CUSTOMER LIST</h3>
      <div class="customer_list">
        <div class="grid-content" id="sectionA">
          <img src="../assets/image/腾瑞制药.png" alt="腾瑞制药" />
        </div>
        <div class="grid-content">
          <img src="../assets/image/医源医疗.png" alt="医源医疗" />
        </div>
        <div class="grid-content">
          <img src="../assets/image/长安天宇.png" alt="长安天宇" />
        </div>
        <div class="grid-content">
          <img
            src="../assets/image/厦门致诚美电子科技有限公司.png"
            alt="厦门致诚美电子科技有限公司"
          />
        </div>
        <div class="grid-content">
          <img src="../assets/image/锐杰微科技(郑州)有限公司.png" alt="" />
        </div>
        <div class="grid-content">
          <img src="../assets/image/公谊.png" alt="公谊" />
        </div>
        <div class="grid-content">
          <img src="../assets/image/东富龙科技集团股份有限公司.png" alt="" />
        </div>
        <div class="grid-content">
          <img src="../assets/image/无锡.png" alt="无锡" />
        </div>
        <div class="grid-content">
          <img
            src="../assets/image/宁波三生生物科技股份有限公司.png"
            alt="宁波三生生物科技股份有限公司"
          />
        </div>
        <div class="grid-content">
          <img src="../assets/image/武汉.png" alt="武汉" />
        </div>
        <div class="grid-content">
          <img src="../assets/image/晶正.png" alt="晶正" />
        </div>
        <div class="grid-content">
          <img src="../assets/image/中农劲腾(江苏)药业有限公司.png" alt="" />
        </div>
        <div class="grid-content">
          <img src="../assets/image/中国大冢制药有限公司.png" alt="" />
        </div>
        <div class="grid-content">
          <img src="../assets/image/瑞阳制药股份有限公司.png" alt="" />
        </div>
        <div class="grid-content">
          <img src="../assets/image/江苏康禾生物制药有限公司.png" alt="" />
        </div>
        <div class="grid-content">
          <img src="../assets/image/大连百利天华制药有限公司.png" alt="" />
        </div>
        <div class="grid-content">
          <img src="../assets/image/常州德创高新材料科技有限公司.png" alt="" />
        </div>
        <div class="grid-content">
          <img
            src="../assets/image/上海科立特农科（集团）有限公司.png"
            alt=""
          />
        </div>
        <div class="grid-content">
          <img src="../assets/image/延锋汽车饰件徐州有限公司.png" alt="" />
        </div>
        <div class="grid-content">
          <img src="../assets/image/河南白云广牧生物科技有限公司.png" alt="" />
        </div>
      </div>

      <!-- <el-row :gutter="20">
        <el-col :span="6"
          ><div class="grid-content" id="sectionA">
            <img src="../assets/image/腾瑞制药.png" alt="腾瑞制药" /></div
        ></el-col>
        <el-col :span="6"
          ><div class="grid-content">
            <img src="../assets/image/医源医疗.png" alt="医源医疗" /></div
        ></el-col>
        <el-col :span="6"
          ><div class="grid-content">
            <img src="../assets/image/长安天宇.png" alt="长安天宇" /></div
        ></el-col>
        <el-col :span="6"
          ><div class="grid-content">
            <img
              src="../assets/image/厦门致诚美电子科技有限公司.png"
              alt="厦门致诚美电子科技有限公司"
            /></div
        ></el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="6"
          ><div class="grid-content">
            <img
              src="../assets/image/锐杰微科技(郑州)有限公司.png"
              alt=""
            /></div
        ></el-col>
        <el-col :span="6"
          ><div class="grid-content">
            <img src="../assets/image/公谊.png" alt="公谊" /></div
        ></el-col>
        <el-col :span="6"
          ><div class="grid-content">
            <img
              src="../assets/image/东富龙科技集团股份有限公司.png"
              alt=""
            /></div
        ></el-col>
        <el-col :span="6"
          ><div class="grid-content">
            <img src="../assets/image/无锡.png" alt="无锡" /></div
        ></el-col>
      </el-row>

      <el-row :gutter="20">
        <el-col :span="6"
          ><div class="grid-content">
            <img
              src="../assets/image/宁波三生生物科技股份有限公司.png"
              alt="宁波三生生物科技股份有限公司"
            /></div
        ></el-col>
        <el-col :span="6"
          ><div class="grid-content">
            <img src="../assets/image/武汉.png" alt="武汉" /></div
        ></el-col>
        <el-col :span="6"
          ><div class="grid-content">
            <img src="../assets/image/晶正.png" alt="晶正" /></div
        ></el-col>
        <el-col :span="6"
          ><div class="grid-content">
            <img
              src="../assets/image/中农劲腾(江苏)药业有限公司.png"
              alt=""
            /></div
        ></el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="6"
          ><div class="grid-content">
            <img src="../assets/image/中国大冢制药有限公司.png" alt="" /></div
        ></el-col>
        <el-col :span="6"
          ><div class="grid-content">
            <img src="../assets/image/瑞阳制药股份有限公司.png" alt="" /></div
        ></el-col>
        <el-col :span="6"
          ><div class="grid-content">
            <img
              src="../assets/image/江苏康禾生物制药有限公司.png"
              alt=""
            /></div
        ></el-col>
        <el-col :span="6"
          ><div class="grid-content">
            <img
              src="../assets/image/大连百利天华制药有限公司.png"
              alt=""
            /></div
        ></el-col>
      </el-row>
      <el-row :gutter="20" style="margin-bottom: 50px">
        <el-col :span="6"
          ><div class="grid-content">
            <img
              src="../assets/image/常州德创高新材料科技有限公司.png"
              alt=""
            /></div
        ></el-col>
        <el-col :span="6"
          ><div class="grid-content">
            <img
              src="../assets/image/上海科立特农科（集团）有限公司.png"
              alt=""
            /></div
        ></el-col>
        <el-col :span="6"
          ><div class="grid-content">
            <img
              src="../assets/image/延锋汽车饰件徐州有限公司.png"
              alt=""
            /></div
        ></el-col>
        <el-col :span="6"
          ><div class="grid-content">
            <img
              src="../assets/image/河南白云广牧生物科技有限公司.png"
              alt=""
            /></div
        ></el-col>
      </el-row> -->
    </div>
  </div>
</template>

<script>
export default {
  name: "CustomerCase",
  mounted() {
    this.scrollToPosition();
  },
  watch: {
    "$route.query.scrollTo"(newVal) {
      this.scrollToPosition(newVal);
    },
  },
  data() {
    return {};
  },
  methods: {
    scrollToPosition(section = null) {
      let element = null;
      if (section) {
        element = document.querySelector(`#${section}`);
      } else {
        // 默认滚动到页面顶部
        element = document.body;
      }
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.adaptive-row {
  width: 100%; /* 使el-row宽度为100%，占据其父容器的全部宽度 */
}

.adaptive-col {
  display: flex; /* 使用弹性布局来使内部元素垂直居中 */
  flex-direction: column; /* 子元素垂直排列 */
  justify-content: center; /* 子元素在垂直方向上居中 */
  align-items: center; /* 子元素在水平方向上居中（如果需要） */
}

p {
  font-size: 20px;
  line-height: 50px;
}
.MainOne {
  height: 500px;
}
el-form-item {
  list-style: 56px;
}
/* 确保外部容器也有适当的样式来适应窗口大小 */
body,
html {
  height: 100%;
  margin: 0;
  padding: 0;
}
.customer_list {
  display: flex;
  justify-content: center;
  flex-wrap: wrap; /* 允许子项换行，但在本例中我们不会让它们换行 */
  margin: 0 auto;
}
/* 使用视口单位vw来设置字体大小，这样字体大小会随着视口宽度的变化而变化 */
.grid-content p {
  font-size: 1.5vw; /* 视口宽度的2%，你可以根据需要调整这个值 */
  /* 为了避免字体过小或过大，可以设置一个最小和最大字体大小 */
  font-size: clamp(
    12px,
    1.5vw,
    24px
  ); /* 字体大小限制在12px到24px之间，中间值根据2vw计算 */
}
.grid-content {
  border-radius: 4px;

  /* 添加阴影 */
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.15);

  /* 圆角 */
  border-radius: 8px;

  /* 背景色和边框 */
  background-color: #ffffff; /* 或者其他你喜欢的颜色 */
  border: 1px solid #e0e0e0; /* 或者其他你喜欢的颜色 */

  /* 其他样式 */
  padding: 20px; /* 内边距 */
  margin: 10px; /* 外边距 */
  text-align: center; /* 文本居中 */
  flex: 0 0 25%; /* 子项不会增长或缩小，固定占据25%的宽度 */
  max-width: 20%; /* 设置最大宽度为25%，防止内容过多时撑大 */
  box-sizing: border-box; /* 包含padding和border在内计算宽度 */
  padding: 10px; /* 可选：添加内边距以美化布局 */
  margin: 5px; /* 可选：添加外边距以分隔子项 */
}
/* 如果需要在小屏幕下改变布局，可以添加媒体查询 */
@media (max-width: 600px) {
  .grid-content {
    flex: 0 0 40%; /* 小屏幕下一行显示两个 */
    max-width: 40%;
  }
}
// .grid-content img {
//   /* 图片居中 */
//   display: block;
//   margin: 0 auto;
//   max-width: 100%; /* 确保图片不会超出容器宽度 */
//   height: auto; /* 保持图片的宽高比 */
// }
.right_letter {
  border-bottom: 2px solid #ccccccf0;
  text-align: right;
  margin-top: 42px;
}
.contact {
  width: 100%;
  height: auto;
  margin: 0 auto;
  background-color: rgb(243, 245, 245);
}
.MainTwo {
  height: auto;
  // margin: 0 auto;
  margin-top: 20px;
  margin-bottom: 40px;
}
.contact hr {
  color: rgb(136, 126, 126);
}
h2 {
  text-align: right;
  text-align: left;
  color: blue;
  margin-top: 10px;
}
.contact h3 {
  text-align: left;
  color: grey;
  margin-bottom: 30px;
}

.el-row {
  margin-bottom: 20px;
  &:last-child {
    margin-bottom: 0;
  }
}
.el-col {
  border-radius: 4px;
}
.bg-purple-dark {
  background: #99a9bf;
}
.bg-purple {
  background: #d3dce6;
}
.bg-purple-light {
  background: #e5e9f2;
}
.row-bg {
  padding: 10px 0;
  background-color: #f9fafc;
}
</style>
